var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":_vm.$t('Groups Numbering'),"description":_vm.$t('From Here You Can Control The Numbering Of Your Groups')}}),_c('indexTable',{attrs:{"searchText":_vm.$t('Search for numbering'),"emptyTableText":_vm.$t('there Is No Numbering'),"localData":true,"buttonRole":true,"emptyTableSubText":_vm.$t('Try adding some items to the table and try again'),"cloumns":[
          {
            column: 'name',
            title: _vm.$t('The Name'),
            type: 'text',
            sort: true
          },
          {
            column: 'prefix',
            title: _vm.$t('The Prefix'),
            type: 'text',
            sort: true
          },
          {
            column: 'next_id',
            title: _vm.$t('next Number'),
            type: 'text',
            sort: true
          },
          {
            column: 'left_pad',
            title: _vm.$t('Left Margin'),
            type: 'text',
            sort: true
          },
          {
            column: 'prefix_year',
            title: _vm.$t('Year Prefix'),
            type: 'trueOrFalse',
            sort: true
          },
          {
            column: 'prefix_month',
            title: _vm.$t('The Month Prefix'),
            type: 'trueOrFalse',
            sort: true
          },
          {
            column: 'options',
            title: _vm.$t('Settings'),
            type: 'options',
            options: [
              { name: 'edit', role: true },
              { name: 'delete', role: true }
            ]
          }
        ],"deleteText":{
          attention: _vm.$t('Attention'),
          areYouReallySureToDeleteTheItem: _vm.$t('Are you really sure to delete the item'),
          close: _vm.$t('Close'),
          confirm: _vm.$t('Confirm'),
          loading: _vm.$t('Loading')
        }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }